export default __webpack_public_path__ + "static/media/evenShotBg.ff0910c6.png";